<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.subscriptions.retrieveLoader">
      <v-boilerplate type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{name: 'CouponListCreate'}" class="subtitle-1 routerLink font-weight-medium">Cupones</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 500px;'">{{instance.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-1" @click="dialogCoupon=true" outlined retain-focus-on-click color="secondary">Editar</v-btn>
              <v-menu close-on-click close-on-content-click left offset-y :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" color="secondary" outlined retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="deleteCoupon">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium">Eliminar cupón</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-row>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Monto</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="instance.discount_scheme === '%'">{{instance.amount | number(false)}} %</template>
                    <template v-if="instance.discount_scheme === '$'">{{instance.amount | currency(instance.currency.id)}} {{instance.currency.id}}</template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Aplicable en</v-list-item-title>
                  <v-list-item-subtitle>{{instance.apply_on === 'invoice' ? 'Suscripción completa' : 'Línea de la suscripción'}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Duración</v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="instance.duration_scheme === 'one_time'">por un ciclo de facturación</span>
                    <span v-if="instance.duration_scheme === 'forever'">por siempre</span>
                    <span v-if="instance.duration_scheme === 'limited'">por {{instance.duration_times}} ciclos de facturación</span>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="instance.valid_until">
                  <v-list-item-title>Válido hasta</v-list-item-title>
                  <v-list-item-subtitle>{{instance.valid_until | date}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- subscription list -->
      <v-card class="mt-3">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Suscripciones activas</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <subscription-list :show-sort="false" :show-pagination="false" :show-criteria="{lines__coupon__id: instance.id}" />
        </v-card-text>
      </v-card>
      <!-- end subscription list -->
    </v-col>

    <!-- dialog addon update -->
    <v-dialog v-model="dialogCoupon" width="600" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar cupón</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCoupon=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                 <v-text-field v-model.trim="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense maxlength="56" placeholder="Escribe un nombre" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCoupon=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="patchCoupon" :loading="$store.state.subscriptions.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog addon update -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import SubscriptionList from '@/components/subscription/SubscriptionList'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    SubscriptionList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    editable: {},
    dialogCoupon: false
  }),
  computed: mapState({
    instance: state => state.subscriptions.couponsDetail,
    subscriptionsCount: state => state.subscriptions.subscriptionsCount,
    subscriptionsList: state => state.subscriptions.subscriptionsList
  }),
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'coupons',
      id: this.$route.params.id
    })
    .then(() => {
      this.editable = Object.assign({}, this.instance)
      const query = {
        page_size: 6
      }
      if (this.instance.apply_on === 'invoice') {
        query.coupon = this.instance.id
      } else {
        query.lines__coupon__id = this.instance.id
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'subscriptions',
        query: query
      })
    })
  },
  methods: {
    patchCoupon () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        name: this.editable.name
      }
      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'coupons',
        id: this.$route.params.id,
        payload: payload
      })
      .then((response) => {
        this.dialogCoupon = false
      })
      .catch(() => {
        this.$dialog.message.error('Error al actualizar el cupón.')
      })
    },
    deleteCoupon () {
      this.$dialog.warning({
        title: 'Eliminar cupón',
        text: `
          <span class="d-block mb-4">Al eliminar este cupón, no podrás asociarlo a nuevas suscripciones. Las suscripciones activas no serán afectadas y se seguirán facturando hasta que se cancelen.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('subscriptions/DESTROY', {
                resource: 'coupons',
                id: this.instance.id
              })
              .then(() => {
                this.$dialog.message.info('El cupón ha sido eliminado')
                this.$router.push({
                  name: 'CouponListCreate',
                  params: {
                    id: this.editable.id
                  }
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    editable: {
      name: {
        required,
        maxLength: maxLength(56)
      }
    }
  }
}
</script>